export default "__VITE_ASSET__5887d85f__"